export const REFERENCE_CODE_PREFIX = 'MG' as const;
export const REFERENCE_CODE_DIGITS = 9 as const;

export const SUPPORTED_LOCALES = ['fr', 'en'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: Locale = 'fr';

export const SUPPORTED_SEND_CURRENCIES = ['EUR', 'USD', 'CAD'] as const;
export const SUPPORTED_RECEIVE_CURRENCIES = ['XAF'] as const;
export type SendCurrency = (typeof SUPPORTED_SEND_CURRENCIES)[number];
export type ReceiveCurrency = (typeof SUPPORTED_RECEIVE_CURRENCIES)[number];

export const PAYOUT_METHODS = ['mobile_money', 'bank'] as const;
export type PayoutMethod = (typeof PAYOUT_METHODS)[number];

export const MOBILE_MONEY_PROVIDERS = ['mtn_momo', 'orange_money'] as const;
export type MobileMoneyProvider = (typeof MOBILE_MONEY_PROVIDERS)[number];

export const ID_DOCUMENT_TYPES = ['passport', 'national_id', 'residency_permit'] as const;
export type IdDocumentType = (typeof ID_DOCUMENT_TYPES)[number];

export const ADMIN_ROLES = ['super_admin', 'operator', 'compliance_reviewer'] as const;
export type AdminRole = (typeof ADMIN_ROLES)[number];

export const TRANSFER_STATUSES = [
  'DRAFT',
  'PENDING_KYC',
  'PENDING_PAYMENT',
  'PAYMENT_RECEIVED',
  'PROCESSING',
  'PAID_OUT',
  'COMPLETED',
  'CANCELLED',
  'FAILED',
  'REFUNDED',
] as const;
export type TransferStatus = (typeof TRANSFER_STATUSES)[number];

export const KYC_STATUSES = ['pending', 'approved', 'rejected'] as const;
export type KycStatus = (typeof KYC_STATUSES)[number];
